module.exports = __webpack_public_path__ + "static/media/apex-x.d8d1ad7a.svg";